export const SHIP_ASSIST_ROUTE_NAMES = {
  EDIT_PACKING_ORDER: 'edit-packing-order',
  PACK_ORDER: 'pack-order',
  SHIP_ASSIST_WILDCARD: 'ship-assist-wildcard',
  SHIP_ASSIST: 'ship-assist',
  TOTES: 'totes',
};
